import { useState, useRef } from "react";
import "./Sustainability24.scss";
import Banner from "../../../Common/Banner/Banner";
import { SUSTAINABILITY_24 } from "../../Sustainability/SustainabilityData";
import TwoColumnLayout from "../../../Common/TwoColumnLayout/TwoColumnLayout";
import Modal from "../../../Common/Modal/modal";
import iconPathURL from "../../../Common/iconPath";

const iconPath = process.env.PUBLIC_URL + "/assets/images/";

export default function Suatainability24() {
  const agendaRef = useRef(null);
  const speakerRef = useRef(null);
  const [isModalVisible, setModalVisibility] = useState(false);
  const [name, setName] = useState("");

  const modalSpeaker = () => {
    let speakerContent = SUSTAINABILITY_24.speakers_info[name];
    return (
      <Modal
        show={isModalVisible}
        handleClose={() => setModalVisibility(false)}
      >
        {speakerContent && (
          <div className="table-content">
            <button
              className="button-container"
              onClick={() => setModalVisibility(false)}
            >
              <img
                style={{ height: 20, width: 20 }}
                src={iconPathURL("common/close.png")}
                alt="img"
              ></img>
            </button>
            <div className="row  modal-view">
              <div className="col-xs-12 col-md-3 col-lg-3">
                <img
                  alt="logo"
                  src={`${iconPath}sustainability-24/${speakerContent.image}`}
                  style={{ width: "70%" }}
                ></img>
              </div>
              <div
                className="col-xs-12 col-md-8 col-lg-8"
                style={{ paddingTop: "4rem" }}
              >
                <span
                  className="speaker-name"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    window.open(speakerContent.url, "_blank");
                  }}
                >
                  {speakerContent.name}
                </span>
                <p className="modal-contents">{speakerContent.designation}</p>
              </div>
            </div>
            <div className="profile-desc">
              <p className="modal-contents">{speakerContent.details1}</p>
              <p className="modal-contents">{speakerContent.details2}</p>
              <p className="modal-contents">{speakerContent.details3}</p>
              <p className="modal-contents">{speakerContent.details4}</p>
            </div>
          </div>
        )}
      </Modal>
    );
  };

  const CardView1 = (props) => {
    const body = () => {
      return (
        <div>
          <th
            style={{ cursor: "pointer" }}
            onClick={() => {
              setName(props.item.name1);
              setModalVisibility(true);
            }}
          >
            {props.item.name1}
          </th>
          <div>
            <p>
              <strong>
                <p className="describe">{props.item.designation1}</p>
              </strong>
            </p>
          </div>
        </div>
      );
    };
    return (
      <div className="text-container-section col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <TwoColumnLayout
          imgStyle="col-xs-12 col-sm-4 col-md-4 col-lg-4 first-column"
          style="col-xs-12 col-sm-8 col-md-8 col-lg-8 second-column"
          imgSrc={
            props.item.image1 &&
            `${`${iconPath}sustainability-24/${props.item.image1}`}`
          }
          body={props.item.image1 && body()}
        ></TwoColumnLayout>
      </div>
    );
  };
  const CardView2 = (props) => {
    const body = () => {
      return (
        <div>
          <th
            style={{ cursor: "pointer" }}
            onClick={() => {
              setName(props.item.name2);
              setModalVisibility(true);
            }}
          >
            {props.item.name2}
          </th>
          <div>
            <p>
              <strong>
                <p className="describe">{props.item.designation2}</p>
              </strong>
            </p>
          </div>
        </div>
      );
    };
    return (
      <div className="text-container-section col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <TwoColumnLayout
          imgStyle="col-xs-12 col-sm-4 col-md-4 col-lg-4 first-column"
          style="col-xs-12 col-sm-8 col-md-8 col-lg-8 second-column"
          imgSrc={
            props.item.image2 &&
            `${`${iconPath}sustainability-24/${props.item.image2}`}`
          }
          body={body()}
        ></TwoColumnLayout>
      </div>
    );
  };

  const sustainabilityTable = () => {
    return (
      <div
        ref={agendaRef}
        className={
          navigator.platform.indexOf("Mac") === -1
            ? "table-content table-win"
            : "table-content table-mac"
        }
      >
        <div className="first-table">
          <h2 className={"agenda-text-24"}>Agenda</h2>
        </div>

        <div className="sustainability-container">
          <div className="time-coulmn time-text">Time</div>
          <div className="session-coulmn time-text">Session</div>
        </div>

        <>
          {SUSTAINABILITY_24.agenda?.map((item) => (
            <div className="row contents sustainability-wrapper">
              <div className="time-coulmn-data">{item.date}</div>
              <div className="session-column-data">{item.session}</div>
            </div>
          ))}
        </>
      </div>
    );
  };
  const speakerTable = () => {
    return (
      <div ref={speakerRef}>
        <div className="table-content">
          <div className="first-table">
            <h2 className="agenda-text-24">SPEAKERS</h2>
          </div>
          <table>
            <div>
              {SUSTAINABILITY_24.speakers?.map((item, index) => (
                <div className="speaker-item">
                  <div className="col-xs-12 col-md-6 col-lg-6 date-text">
                    <CardView1 item={item} index={index} />
                  </div>
                  {item.name2 !== "" && (
                    <div className="col-xs-12 col-md-6 col-lg-6 date-text">
                      <CardView2 item={item} index={index} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </table>
        </div>
      </div>
    );
  };

  const handleRegisterNow = () => {
    const registerUrl =
      "https://www.mbrdi.co.in/assets/docs/Sustainability%20Dialogue%20India%202024%20-%20Press%20Release.pdf";
    window.open(registerUrl, "_blank");
  };

  return (
    <div className="sustain-container">
      {modalSpeaker()}
      <div>
        <Banner
          imgSrc={iconPath + "sustainability-24/sustain_24.png"}
          title=""
        />
        <div className="btn-container">
          <button onClick={handleRegisterNow} className="register-now-btn">
            Read the Press Announcement
          </button>
        </div>
      </div>
      {sustainabilityTable()}
      {speakerTable()}
    </div>
  );
}
